<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getDictionary } from '@/api/common'
export default {
  name: 'App',
  components: {
  },
  mounted() {
    this.getDicList()
    window.addEventListener("orientationchange", function () {
      // 禁止横屏
      if (window.orientation === 90 || window.orientation === -90) {
        alert("请将手机调整至竖屏模式！");
        window.orientation == 0
      }
    });
  },
  methods: {
    async getDicList() {
      const { data } = await getDictionary({ code: 'chain_domain' })
      const eventUrlArr = data.filter(item => item.dictKey === "event_url")
      this.$store.commit('SET_EVENTPOINT_URL', eventUrlArr[0].dictValue)

    }
  }
}
</script>

<style></style>
